export const HEADINGS = [
  {
    title: '👋 Olá! Vai ser para quando?',
    description:
      'Selecione o dia da entrega. O horário será definido posteriormente.',
  },
  {
    title: 'Sobre seu bolo',
    description:
      'Lembre-se que o preço da massa e outros itens serão multiplicados pelo peso.',
  },
  {
    title: 'Recheios 😋',
    description: 'Você pode escolher até <span>2 recheios</span> diferentes.',
  },
  {
    title: 'Detalhes e adicionais',
    description:
      'Você pode deixar seu bolo ainda mais especial escolhendo uma cobertura, <span>múltiplos adicionais</span> e doces artesanais.',
  },
  {
    title: 'Revise seu pedido',
    description:
      'Caso o endereço de entrega não seja preenchido, o pedido deverá ser retirado em <span><a href="https://maps.app.goo.gl/kE4mz2Q91ApGcCPZ8" target="_blank" rel="noopener noreferrer">R. João Fernandes, 125 - Jd. Nossa Sra. do Carmo</a></span>.',
  },
]
